import JobZImage from "../../../common/jobz-img";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { loadScript, setMenuActive } from "../../../../globals/constants";
import { employer, empRoute, publicUser } from "../../../../globals/route-names";
import { useEffect } from "react";
import { useAuth } from "../../../../context/AuthContext";

function EmpSidebarSection(props) {
    const currentpath = useLocation().pathname;
    const navigate = useNavigate();
    const { logout, deleteProfile } = useAuth();

    useEffect(() => {
        loadScript("js/custom.js");
        loadScript("js/emp-sidebar.js");
    })

    const goTo = (path) => {
        navigate(path);
    };

    const handleLogout = async () => {
        if (!window.confirm("Logout from your employer account?")) return;
        await logout();
        navigate(publicUser.pages.LOGIN);
    };

    const handleDeleteProfile = async () => {
        if (!window.confirm("Delete this employer profile? Your account will be deactivated and you will be logged out.")) return;
        await deleteProfile();
        navigate(publicUser.pages.LOGIN);
    };

    return (
        <>
            <nav id="sidebar-admin-wraper" className={props.sidebarActive ? "" : "active"}>
                <div className="page-logo">
                    <NavLink to={publicUser.HOME1}><JobZImage id="skin_page_logo" src="images/zozojobs-logo.png" alt="Zozo Jobs" /></NavLink>
                </div>
                <div className="admin-nav scrollbar-macosx">
                    <ul>
                        <li
                            className={setMenuActive(currentpath, empRoute(employer.DASHBOARD))}>
                            <NavLink to={empRoute(employer.DASHBOARD)}><i className="fa fa-home" /><span className="admin-nav-text">Dashboard</span></NavLink>
                        </li>
                        <li
                            className={setMenuActive(currentpath, empRoute(employer.PROFILE))}>
                            <NavLink to={empRoute(employer.PROFILE)}><i className="fa fa-user-tie" /><span className="admin-nav-text">Company Profile</span></NavLink>
                        </li>
                        <li
                            className={setMenuActive(currentpath, empRoute(employer.COMPANIES))}>
                            <NavLink to={empRoute(employer.COMPANIES)}><i className="fa fa-building" /><span className="admin-nav-text">Companies</span></NavLink>
                        </li>
                        <li
                            className={
                                setMenuActive(currentpath, empRoute(employer.POST_A_JOB)) +
                                setMenuActive(currentpath, empRoute(employer.MANAGE_JOBS))
                            }>
                            <button type="button" className="admin-nav-toggle employer-nav-button" onClick={() => goTo(empRoute(employer.MANAGE_JOBS))}>
                                <i className="fa fa-suitcase" />
                                <span className="admin-nav-text">Jobs</span>
                            </button>
                            <ul className="sub-menu">
                                <li> <NavLink to={empRoute(employer.POST_A_JOB)} id="jobMenuId1"><span className="admin-nav-text">Post a New Jobs</span></NavLink></li>
                                <li> <NavLink to={empRoute(employer.MANAGE_JOBS)} id="jobMenuId2"><span className="admin-nav-text">Manage Jobs</span></NavLink></li>
                            </ul>
                        </li>
                        <li className={setMenuActive(currentpath, empRoute(employer.CANDIDATES))}>
                            <NavLink to={empRoute(employer.CANDIDATES)}><i className="fa fa-user-friends" /><span className="admin-nav-text">Candidates</span></NavLink>
                        </li>
                        <li className={setMenuActive(currentpath, empRoute(employer.BOOKMARKS))}>
                            <NavLink to={empRoute(employer.BOOKMARKS)}><i className="fa fa-bookmark" /><span className="admin-nav-text">Bookmark Resumes</span></NavLink>
                        </li>
                        <li
                            className={
                                setMenuActive(currentpath, empRoute(employer.MESSAGES1)) +
                                setMenuActive(currentpath, empRoute(employer.MESSAGES2))
                            }
                        >
                            <button type="button" className="admin-nav-toggle employer-nav-button" onClick={() => goTo(empRoute(employer.MESSAGES1))}>
                                <i className="fa fa-envelope" />
                                <span className="admin-nav-text">Messages <sup className="twm-msg-noti">5</sup></span>
                            </button>
                            <ul className="sub-menu">
                                <li> <NavLink to={empRoute(employer.MESSAGES1)} id="msgMenuId1"><span className="admin-nav-text">MSG Style-1</span></NavLink></li>
                                <li> <NavLink to={empRoute(employer.MESSAGES2)} id="msgMenuId2"><span className="admin-nav-text">MSG Style-2</span></NavLink></li>
                            </ul>
                        </li>
                        <li className={setMenuActive(currentpath, empRoute(employer.RESUME_ALERTS))}>
                            <NavLink to={empRoute(employer.RESUME_ALERTS)}><i className="fa fa-bell" /><span className="admin-nav-text">Resume Alerts</span></NavLink>
                        </li>
                        <li className={setMenuActive(currentpath, empRoute(employer.SUPPORT))}>
                            <NavLink to={empRoute(employer.SUPPORT)}><i className="fa fa-headset" /><span className="admin-nav-text">Support Tickets</span></NavLink>
                        </li>
                        <li>
                            <button type="button" className="employer-nav-button" onClick={handleDeleteProfile}><i className="fa fa-trash-alt" /><span className="admin-nav-text">Delete Profile</span></button>
                        </li>
                        <li>
                            <button type="button" className="employer-nav-button" onClick={handleLogout}>
                                <i className="fa fa-share-square" />
                                <span className="admin-nav-text">Logout</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default EmpSidebarSection;
